/**
 * Sort rows by a column, given a map of accessors.
 *
 *   const ACCESSORS = {
 *       name: (u) => u.name.toLowerCase(),
 *       version: (u) => versionSortKey(u.systemInfo?.appVersion),
 *       lastActive: (u) => u.lastActiveSort,     // Infinity for "never"
 *   };
 *   const rows = useMemo(() => sortRows(filtered, sort, ACCESSORS), [filtered, sort]);
 *
 * Lives here rather than in the table component so every table sorts identically
 * and so accessors can use the version-aware comparison in lib/format.js — a
 * plain string compare puts 1.2.10 before 1.2.8.
 *
 * Numeric accessors may return Infinity to mean "no value"; those rows land last
 * when ascending, which is what you want for "last active: never".
 */
export function sortRows(rows, sort, accessors) {
    if (!sort?.by || !accessors?.[sort.by]) return rows;

    const get = accessors[sort.by];
    const factor = sort.dir === "asc" ? 1 : -1;

    return [...rows].sort((a, b) => {
        const va = get(a);
        const vb = get(b);

        if (typeof va === "string" || typeof vb === "string") {
            return String(va ?? "").localeCompare(String(vb ?? "")) * factor;
        }
        return ((va ?? 0) - (vb ?? 0)) * factor;
    });
}

/** Toggle helper for a SortableTh click: same column flips, new column starts asc. */
export function nextSort(current, field, defaultDir = "asc") {
    if (current?.by !== field) return { by: field, dir: defaultDir };
    return { by: field, dir: current.dir === "asc" ? "desc" : "asc" };
}
